/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import axios from "axios";
import { removeTrashFilterInterceptor } from "./trashedProjectFilter";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.headers.common["Prodtrack-api-version"] = "latest";

const defaultRequest = axios;

const tableRequest = axios.create();

defaultRequest.interceptors.request.use(removeTrashFilterInterceptor);
tableRequest.interceptors.request.use(removeTrashFilterInterceptor);

tableRequest.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response?.status === 404) {
            window.location.replace("/404_not_found");
        }
        if (error.response?.status === 403) {
            window.location.replace("/403_forbidden");
        }
        return Promise.reject(error);
    }
);

export { tableRequest };

export default defaultRequest;
